module.exports = __webpack_public_path__ + "static/media/Bal_Diwali_m_mr.ed544ee9.jpg";